<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Reporte de valores recaudados</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button @click="consultar" class="btn-info btn--bigger">
						<i class="fa fa-search"></i><span>Consultar</span>
					</button>
          <button type="button" @click="mostrarHistoricos" class="btn-secondary">
            <i class="fa fa-history"></i><span>Historial</span>
          </button>
          <button @click="exportar" class="btn-success btn--bigger">
						<i class="fa fa-file-excel-o"></i><span>Exportar</span>
						</button>
        </div>
      </div>
    </div>
    <div class="card mt-2">
      <div class="card__title">
        <h5>Filtros de la consulta</h5>
      </div>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <VueCtkDateTimePicker id="desde" v-model="form.desde" locale="es" only-date no-label
                  button-now-translation="Ahora" format="YYYY-MM-DD" formatted="YYYY-MM-DD"
                  label="Seleccione fecha..." />
                <label>Desde</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <VueCtkDateTimePicker id="hasta" v-model="form.hasta" locale="es" only-date no-label
                  button-now-translation="Ahora" format="YYYY-MM-DD" formatted="YYYY-MM-DD"
                  label="Seleccione fecha..." />
                <label>Hasta</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select placeholder="Seleccione..." :options="recaudadores" id="recaudador" name="recaudador" multiple
                  @input="inputRecaudador" v-model="selectedRecaudador" @search="searchRecaudadores" label="nombre">
                </v-select>
                <label for="recaudador">Recaudador</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field select2 select2-field--stretch">
              <div class="select2-field">
                <v-select :filterable="false" @input="inputBodega" label="descripcion" placeholder="Seleccione..."
                  :options="bodegas" id="bodegas" v-model="selectedBodega"></v-select>
                <label for="bodegas">Sucursal</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select placeholder="Seleccione..." :options="rutas" id="ruta" name="ruta" @input="inputRuta"
                  v-model="selectedRuta" @search="searchRutas" label="descripcion">
                </v-select>
                <label for="rutas">Ruta</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field select">
              <div class="select-field">
                <select v-model="form.tipo_venta" name="tipo_venta" id="tipo_venta">
                  <option value="">Todos</option>
                  <option value="V">Venta</option>
                  <option value="R">Recaudación</option>
                </select>
                <label for="tipo_venta">Tipo de venta</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="dias.length > 0" class="card mt-2">
      <div class="card__content">
        <div style="max-height: 300px" class="table-responsive">
          <table class="custom-table">
            <thead>
              <tr>
                <th colspan="10" class="text-center">
                  Valores de recaudación {{ periodo }}
                </th>
              </tr>
              <tr>
                <th>Sucursal</th>
                <th>Ruta</th>
                <th>Tipo de venta</th>
                <th v-for="dia in dias" :key="dia">
                  {{ dia }}
                </th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in consulta"
                :key="index + item.bodega_id + item.ruta + item.tipo_venta">
                <td>
                  {{ item.descripcion_bodega }}
                </td>
                <td v-if="!item.total">
                  {{ item.ruta }}
                </td>
                <td v-else>
                  <strong>{{ item.nombre }}</strong>
                </td>
                <td>
                  {{ item.tipo_venta }}
                </td>
                <td v-for="dia in dias" :key="dia">
                  <span v-if="!item.total">
                    {{ moneyFormat(item[dia]) + ' (' + item['total_ventas_' + dia] + ')' }}
                  </span>
                  <strong v-else>
                    {{ moneyFormat(item[dia]) + ' (' + item['total_ventas_' + dia] + ')' }}
                  </strong>
                </td>
                <td>
                  <strong>{{ totalPorRecaudador(item) }}</strong>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th scope="row" colspan="3">
                  Total
                </th>
                <td v-for="dia in dias" :key="dia + 'total'">
                  <strong>{{ totalPorDia(dia) }}</strong>
                </td>
                <td>
                  <strong>{{ totalFinal() }}</strong>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
    <modal name="historicos" height="auto" width="70%" scrollable adaptive resizable reset>
      <reportes-historicos-excel tipoReporte='vr'></reportes-historicos-excel>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    bodegas: {
      type: Array,
      required: false,
      default: function () {
        return [];
      }
    }
  },
  methods: {
    inputBodega: function () {
      if (this.selectedBodega != null)
        this.form.bodega_id = this.selectedBodega.id;
      else
        this.form.bodega_id = '';
    },
    totalFinal: function () {
      let total = 0;
      let total_ventas = 0;
      for (let i = 0; i < this.consulta.length; i++) {
        for (let j = 0; j < this.dias.length; j++) {
          if (!this.consulta[i].total) {
            total += parseFloat(this.consulta[i][this.dias[j]]);
            total_ventas += parseFloat(this.consulta[i]['total_ventas_' + this.dias[j]]);
          }
        }
      }
      return `${moneyFormat(total)} (${total_ventas})`;
    },
    totalPorDia: function (dia) {
      let total = 0;
      let total_ventas = 0;
      for (let i = 0; i < this.consulta.length; i++) {
        if (!this.consulta[i].total) {
          total += parseFloat(this.consulta[i][dia]);
          total_ventas += parseFloat(this.consulta[i]['total_ventas_' + dia]);
        }
      }
      return `${moneyFormat(total)} (${total_ventas})`;
    },
    totalPorRecaudador: function (recaudador) {
      let total = 0;
      let total_ventas = 0;
      for (let i = 0; i < this.dias.length; i++) {
        total += parseFloat(recaudador[this.dias[i]]);
        total_ventas += parseFloat(recaudador['total_ventas_' + this.dias[i]]);
      }
      return `${moneyFormat(total)} (${total_ventas})`;
    },
    mostrarHistoricos: function () {
      this.$modal.show('historicos');
    },
    serialize: function (obj) {
      return (
        "?" +
        Object.keys(obj)
          .reduce(function (a, k) {
            let val = obj[k];
            let esArray = false;
            if (val instanceof Date) {
              val = val.toLocaleDateString("en");
            } else if (val instanceof Array) {
              esArray = true;
              let acumulador = "";
              for (let i = 0; i < val.length; i++) {
                acumulador += k + "%5B%5D=" + val[i];
                if (i != val.length - 1) {
                  acumulador += "&";
                }
              }
              val = acumulador;
              a.push(val);
            }
            if (!esArray) a.push(k + "=" + encodeURIComponent(val));
            return a;
          }, [])
          .join("&")
      );
    },
    exportar: function () {
      this.form.exportar = 'E';
      window.open(url + '/reporte-valores-recaudados' + this.serialize(this.form), '_blank');
    },
    inputRecaudador: function () {
      this.form.recaudadores_id.splice(0, this.form.recaudadores_id.length);
      for (let i = 0; i < this.selectedRecaudador.length; i++)
        this.form.recaudadores_id.push(this.selectedRecaudador[i].id);
    },
    inputRuta: function () {
      if (this.selectedRuta != null)
        this.form.ruta_id = this.selectedRuta.id;
      else
        this.form.ruta_id = '';
    },
    consultar: function () {
      this.form.exportar = 'N';
      axios.get(url + '/reporte-valores-recaudados', {
        params: this.form
      }).then(({ data }) => {
        this.consulta = data.reporte;
        this.dias = data.dias;
        this.periodo = data.periodo;
        if (this.dias.length === 0)
          swal('No hay información para mostrar.', 'Aviso', 'warning');
      }).catch(() => {
        swal('Hubo un error, intente nuevamente.', 'Error', 'error')
      });
    },
    searchRecaudadores: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.recaudadores = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open(
        "GET",
        url + "/search/usuarios?incluir_mixtos=S&tipo=R&search=" + search,
        true
      );
      xmlhttp.send();
    },
    searchRutas: function (search, loading) {
      loading(true);
      const that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.rutas = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open(
        "GET",
        url + "/search/rutas?search=" + search,
        true
      );
      xmlhttp.send();
    },
  },
  data: function () {
    return {
      form: {
        desde: '',
        hasta: '',
        recaudadores_id: [],
        ruta_id: '',
        exportar: 'N',
        bodega_id: '',
        tipo_venta: ''
      },
      selectedRecaudador: [],
      selectedRuta: [],
      recaudadores: [],
      rutas: [],
      consulta: [],
      dias: [],
      moneyFormat: moneyFormat,
      selectedBodega: null,
      periodo: ''
    };
  },
  mounted: function () {
    let hasta = new Date();
    let desde = new Date();
    desde.setDate(desde.getDate() - 6);
    this.form.desde = moment(desde).format('YYYY-MM-DD');
    this.form.hasta = moment(hasta).format('YYYY-MM-DD');
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/pedidos/ReporteValoresRecaudados.vue